.expandChevron {
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 9px;
  opacity: 0.4;
  user-select: none;
  z-index: 1;
  transition: opacity 0.15s, transform 0.15s;

  &:hover {
    opacity: 0.9;
  }
}

.expandChevronOpen {
  transform: translateY(-50%) rotate(90deg);
}

.rowColWithSwitch {
  display: flex;
  justify-content: center;
}

.rowCol {
  text-align: start;
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &.clickAble {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.tagContainer {
  border-radius: 6px;
  background: #d8dde3;
  padding: 2px 4px;
  display: inline-flex;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  @include themify($themes) {
    background-color: themed("neutral-secondary");
    color: themed("main-primary");
  }
}

.row {
  margin: 0 12px;
  opacity: 1;
  height: 55px;
  display: flex;
  text-decoration: none;
  align-items: center;
  position: relative;

  &:not(.rowHoverDisabled) {
    cursor: pointer;

    .tableGrid {
      border-radius: 12px;
      transition: background-color 0.15s ease-out;

      &:hover {
        transition: background-color 0.15s ease-in;
        @include themify($themes) {
          background-color: themed("neutral-tertiary");
        }
      }
    }
  }
}

.tableGridWrapperExpandable {
  padding-left: 2px;
}

.tableGridWrapper {
  height: 100%;
  display: flex;
  padding: 6px 0;
  @include themify($themes) {
    border-bottom: solid 1px themed("neutral-secondary");
  }
  min-width: fit-content;
  width: 100%;
}

.switchCol,
.booleanIconsColumn {
  display: flex;
  justify-content: center;
}

.tagsColumn {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.booleanIconsColumn {
  cursor: pointer;

  &.disabled {
    cursor: auto;
  }
}

.tableGrid {
  position: relative;

  .actionsMenu {
    position: absolute;
    right: 6px;
  }

  .hoverActionsWrapper {
    position: absolute;
    right: 6px;
    display: flex;
    align-items: center;
    column-gap: 6px;
    opacity: 0;
    transition: opacity 0.25s ease-out;
    padding-left: 6px;
    @include themify($themes) {
      background: linear-gradient(to left, themed("neutral-tertiary") calc(100% - 6px), transparent);
    }

    &.unsetBg {
      background: unset;
    }
  }

  &:hover .hoverActionsWrapper {
    opacity: 1;
    transition: opacity 0.25s ease-in;
  }
}

.hoverAction {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  @include themify($themes) {
    background-color: themed("main-secondary");
    color: themed("main-primary");
  }

  svg {
    height: 12px;
    width: 12px;
  }
}

.centerSingleTag {
  display: flex;
  align-items: center;
  justify-content: center;
}

.singleTagContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  height: 24px;
  width: 54px;
  border-radius: 8px;
}

.checkboxWrapper {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -12px;

  .checkbox {
    @include themify($themes) {
      border: 1px solid themed("main-primary");
    }

    &.checkboxChecked {
      @include themify($themes) {
        border: 1px solid themed("checkbox_check_background");
      }
    }
  }
}
